/**
 * KM header locale popover: Region / Language / Currency tabs (data-km-loc-tabs).
 */
(function () {
  function init(root) {
    if (root.dataset.kmLocTabsReady === '1') return;
    root.dataset.kmLocTabsReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.km-loc-tabs__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-km-loc-tabs-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, j) {
          var on = j === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          t.classList.toggle('km-loc-tabs__tab--active', on);
          panels[j].hidden = !on;
        });
      });
    });

    /* Region search sits above the tab row; the country list is inside the Region panel. If Language
       (or Currency) is active, that panel is [hidden] — Horizon's filterCountries still runs (document
       capture) but the list is invisible. Switch to Region *before* filter: window capture runs before
       document capture. */
    var searchInput = root.querySelector('.km-loc-tabs__search .country-filter__input');
    if (searchInput && panels[0] && tabs[0]) {
      function ensureRegionVisible() {
        if (panels[0].hidden) {
          tabs[0].click();
        }
      }
      searchInput.addEventListener('focus', ensureRegionVisible);
      window.addEventListener(
        'input',
        function (ev) {
          if (ev.target === searchInput) ensureRegionVisible();
        },
        true
      );
    }
  }

  document.querySelectorAll('[data-km-loc-tabs]').forEach(init);

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target || !ev.target.querySelectorAll) return;
    ev.target.querySelectorAll('[data-km-loc-tabs]').forEach(init);
  });
})();
